import React from 'react';
import PropTypes from 'prop-types';
import paddleImage from "../assets/images/logo_paddle.png";
import battleImage from "../assets/images/logo_battle.png";
import {Col, Image, Row} from "react-bootstrap";
import '../styles/BigLogo.css';

BigLogo.propTypes = {};

function BigLogo() {
    const logoStyle = {
        maxHeight: '50px', // Set maximum height for the images
        width: 'auto', // Allow the width to adjust based on the height constraint
        animation: 'floatAnimation 3s infinite alternate', // Apply CSS animation
    };

    return (
        <Row>
            <Col className="d-flex flex-column align-items-center">
                <Image className={"my-3"} src={paddleImage} alt="logo-part1" style={logoStyle}/>
                <Image className={"my-3"} src={battleImage} alt="logo-part2" style={logoStyle}/>

            </Col>
        </Row>
    );
}


export default BigLogo;